// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FrontController from "./front_controller.js"
application.register("front", FrontController)

import JobController from "./job_controller.js"
application.register("job", JobController)

import HighlightJSController from "./hljs_controller.js"
application.register("hljs", HighlightJSController)

import TocController from "./toc_controller.js"
application.register("toc", TocController)